export default __webpack_public_path__ + "static/media/4-2_image12@2x.5dcf89ab.png";